export const REFERENCE_DETAIL_FETCH = 'REFERENCE_DETAIL_FETCH';
export const REFERENCE_DETAIL_SUCCESS = 'REFERENCE_DETAIL_SUCCESS';
export const REFERENCE_DETAIL_FAILURE = 'REFERENCE_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ReferenceDetail/actionTypes.js